import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from '../../icons/essentials/DragHandle';
import styles from './DraggableGrid.module.scss';
export const DraggableComponent = (param)=>{
    let { id, children, testIds, dragMode, itemHandleVisibility, itemDragActivation, itemHandlePosition, minHeight } = param;
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging: isThisItemDragging } = useSortable({
        id
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        minHeight: minHeight ? "".concat(minHeight, "px") : undefined
    };
    const fullItemListeners = itemDragActivation === 'full' ? listeners : {};
    const handleActivatorProps = itemDragActivation === 'handle' ? _object_spread({
        ref: setActivatorNodeRef
    }, listeners) : {};
    const handleVisibilityClass = itemHandleVisibility === 'hover' && !isThisItemDragging ? styles.handleHover : styles.handleAlways;
    const dragHandleElement = /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: "".concat(styles.dragHandle, " ").concat(handleVisibilityClass),
        "data-testid": testIds.dragHandle()
    }, handleActivatorProps), {
        children: /*#__PURE__*/ _jsx(DragHandle, {
            size: 20
        })
    }));
    const draggingClass = isThisItemDragging ? dragMode === 'withGhost' ? styles.draggingGhost : styles.draggingSolid : '';
    const itemClassName = [
        styles.sortableItem,
        draggingClass
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        ref: setNodeRef,
        style: style,
        className: itemClassName
    }, attributes, fullItemListeners), {
        children: [
            itemHandlePosition === 'outside' && dragHandleElement,
            /*#__PURE__*/ _jsx("div", {
                className: styles.itemContent,
                "data-testid": testIds.item(),
                children: children({
                    dragHandle: itemHandlePosition === 'inside' ? dragHandleElement : undefined
                })
            })
        ]
    }));
};
